const GLYPH = { USD: "$", GBP: "£", EUR: "€", AUD: "A$", CAD: "C$" };

/**
 * Small circular currency glyph for forms (pairs with ISO acronym labels).
 */
export default function SalaryCurrencyIcon({ currency, size = 18, className = "" }) {
  const code = String(currency || "GBP")
    .trim()
    .toUpperCase();
  const glyph = GLYPH[code] || "?";
  const cn = ["salary-currency-icon", className].filter(Boolean).join(" ");

  return (
    <svg className={cn} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="currentColor" opacity="0.1" />
      <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" strokeWidth="1.25" opacity="0.35" />
      <text
        x="12"
        y="15.5"
        textAnchor="middle"
        fontSize="11.5"
        fontWeight="700"
        fill="currentColor"
        fontFamily="system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif"
      >
        {glyph}
      </text>
    </svg>
  );
}
